var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.3353,
    cy: 51.6644,
    r: 50.3226,
    fill: "#E7E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.6083 72C64.863 72 60.1745 70.9659 55.5431 68.8977C50.9116 66.8294 46.6977 63.8964 42.9014 60.0986C39.1051 56.3008 36.1728 52.0869 34.1046 47.4569C32.0364 42.827 31.0015 38.1386 31 33.3917C31 32.7083 31.2278 32.1389 31.6833 31.6833C32.1389 31.2278 32.7083 31 33.3917 31H42.6167C43.1481 31 43.6227 31.1807 44.0403 31.5421C44.4579 31.9035 44.7046 32.3302 44.7806 32.8222L46.2611 40.7944C46.337 41.4019 46.3181 41.9144 46.2042 42.3319C46.0903 42.7495 45.8815 43.1102 45.5778 43.4139L40.0542 48.9944C40.8134 50.3991 41.7147 51.7559 42.7579 53.0648C43.8011 54.3738 44.9499 55.6364 46.2042 56.8528C47.381 58.0296 48.6148 59.1214 49.9056 60.1282C51.1963 61.135 52.563 62.0552 54.0056 62.8889L59.3583 57.5361C59.7 57.1944 60.1464 56.9386 60.6977 56.7685C61.2489 56.5984 61.7895 56.5506 62.3194 56.625L70.1778 58.2194C70.7093 58.3713 71.1458 58.6469 71.4875 59.0463C71.8292 59.4456 72 59.8913 72 60.3833V69.6083C72 70.2917 71.7722 70.8611 71.3167 71.3167C70.8611 71.7722 70.2917 72 69.6083 72Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCallIcon);
export default __webpack_public_path__ + "static/media/modal-call-icon.cda91ca709aba99dd247e2456c06496a.svg";
export { ForwardRef as ReactComponent };